import { Component, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../../../shared/utils/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  public parameters;
  public vh = window.innerHeight * 0.01;


  @Output()
  public isClicked = new EventEmitter();

  constructor(
    private authService: AuthService
  ) { 
    this.parameters = this.authService.getParameters();
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    document.documentElement.style.setProperty('--bannerTop', this.authService.getParameters().bannerTop);
  }

  public onArrow(): void {
    this.isClicked.emit(true);
  }

}
